var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{ref:"searchbox",staticClass:"searchbox",attrs:{"type":"text","placeholder":"Ingresa una dirección"}}),_c('div',{ref:"map",staticStyle:{"width":"100%","height":"250px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }